import {Link, Typography} from "@mui/material";
import React, {useState} from "react";
import css_shared from "./css/LoginCommon.module.scss";
import css_self from "./css/LoginSecure1.module.scss";
import {useLoginContext} from "./Login";
import LoginSecureBox from "./LoginSecureBox";

export default function LoginSecure1(props) {

    const [sending, setSending] = useState(false);
    const [errorText, setErrorText] = useState(undefined);

    const {
        preSessionState,
        updatePreSessionState,
        abortLogin,
    } = useLoginContext();

    function loginSecureBox(id) {
        const type = id.endsWith("Phone") ? "Phone" : "Email";
        return (
            <LoginSecureBox
                variant="simple"
                type={type}
                value={preSessionState.secureLogin[id]}
                status={preSessionState.secureLogin[`${id}VerifiedState`]}
                disabled={sending}
                onVerificationSending={sending => setSending(sending)}
                onVerificationSendSuccess={async () => {
                    updatePreSessionState(state => {
                        return {...state, secureLogin: {...state.secureLogin, userIdentifierType: id}};
                    });
                }}
                onVerificationSendFailed={response => {
                    if (response instanceof Error && response.message === "Network Error") {
                        setErrorText("Connection not available");
                        return;
                    }
                    setErrorText("Service temporarily unavailable");
                }}
            />
        );
    }

    return (
        <form onSubmit={e => e.preventDefault()}>
            <Typography className={css_shared.Title}>Secure login</Typography>
            <Typography className={css_self.InstructionText}>It looks like you are logging in from an unrecognized device. Please verify your identity.</Typography>
            {loginSecureBox("Email")}
            {loginSecureBox("Phone")}
            <Typography className={css_self.ErrorText} style={{visibility: errorText ? undefined : "hidden"}}>{errorText}</Typography>
            <Typography className={css_self.LogoutInsteadText}>
                Having trouble?{" "}
                <Link href="#" onClick={async e => {
                    e.preventDefault();
                    abortLogin();
                }}>
                    Logout
                </Link>
            </Typography>
        </form>
    );
}
